import { useParams } from "react-router";
import { urls } from "../../../../config/url";
import { IModuleInfo } from "../../../../redux/progress/module/moduleInterface";
import httpRequest from "../../../../utils/HttpRequest";

export function useUpdateModule(
    // updateModule: (modules: IModuleInfo[]) => void
): () => Promise<IModuleInfo[]> {

    const { spec, tech } = useParams<{ spec: string, tech: string }>()

    return () => {
        return httpRequest(urls.listMoudle, {
            SPECIALITYCLASS: spec,
            TECHNOLOGYCLASS: tech,
        }).then(response => {
            if (response.data.errno === 0) {
                let modules: IModuleInfo[] = response.data.data;
                modules = modules.sort((a: IModuleInfo, b: IModuleInfo) => {
                    return a.PRO_MODULE_EXECORDER - b.PRO_MODULE_EXECORDER;
                });
                // updateModule(modules);
                return modules;
            } else {
                throw new Error(response.data.errmsg);
            }
        })
    }
}